import type { Step } from '@/components/wizard/Step';

import { ConfigureManagementAccess } from './configureManagementAccess';
import { ConnectSourceAccount } from './connectSourceAccount';
import { ConnectVaultAccount } from './connectVaultAccount';
import { SetupBackupAccount } from './setupBackupAccount';

export interface SetupOwnCloudState {
  tenantId: string;
  eonBackupApplicationName: string;
  eonBackupApplicationId: string;
  eonBackupApplicationServicePrincipalId?: string;
  customerBackupAppId?: string;
  customerBackupAppServicePrincipalId?: string;
  backupSubscriptionId?: string;
  vaultSubscriptionId?: string;
  sourceSubscriptionId?: string;
  sourceManagementGroupId?: string;
  regionName?: string;
  adxClusterId?: string;
  adxClusterIdentity?: string;
  adxClusterUri?: string;
  connectType: 'managementGroup' | 'subscription';
}

export const setupOwnCloudFlow: Step<SetupOwnCloudState> = {
  name: 'Configure management access',
  Component: ConfigureManagementAccess,
  nonReturnable: true,
  next: [
    {
      name: 'Set up Backup account',
      Component: SetupBackupAccount,
      next: [
        {
          name: 'Connect Vault account',
          Component: ConnectVaultAccount,
          next: [
            {
              name: 'Connect source account',
              Component: ConnectSourceAccount,
            },
          ],
        },
      ],
    },
  ],
};
